import { defineStore } from 'pinia';

import { SnackbarConfiguration } from './types';

export const useSnackbarStore = defineStore('snackbar', {
    state: (): SnackbarConfiguration => ({
        success: false,
        permanent: false,
        message: null,
    }),
    actions: {
        setSnackbarContent(configuration: SnackbarConfiguration | null) {
            Object.assign(
                this,
                configuration || { success: false, message: null, permanent: false },
            );
        },
        displaySnackbar(configuration: Partial<SnackbarConfiguration> | null) {
            this.setSnackbarContent(
                configuration
                    ? { success: false, permanent: false, message: null, ...configuration }
                    : null,
            );
        },
    },
});
